import React, {useEffect, useState} from "react";
import { Form, Badge } from "react-bootstrap";

const StringArrayInput = (props) => {
  const [inputValue, setInputValue] = useState("");
  const [values, setValues] = useState(props.value);

  useEffect(() => {
    setValues(props.value);
  }, [props.value]);

  const handleAdd = (e) => {
    e.preventDefault();
    if (inputValue.trim() !== "") {
      let newValues
      if(values){
        newValues = [...values, inputValue.trim()];
      }else{
        newValues = [inputValue.trim()];
      }
      setValues(newValues);
      setInputValue("");
      props.onChange && props.onChange(newValues);
    }
  };

  const handleDelete = (index) => {
    if(window.confirm('Are you really want to remove this?')){
      const newValues = values.filter((_, i) => i !== index);
      setValues(newValues);
      props.onChange && props.onChange(newValues);
    }
  };

  return (
    <Form.Group className="d-flex flex-wrap align-items-center border p-2 rounded">
      {values && values.map((val, index) => (
        <Badge
          key={index}
          pill
          variant="secondary"
          className="me-1 mb-1"
          onClick={() => handleDelete(index)}
          style={{ cursor: "pointer" }}
        >
          {val} ×
        </Badge>
      ))}
      <Form.Control
        type="text"
        placeholder={props.placeholder || ''}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyPress={(e) => e.key === "Enter" && handleAdd(e)}
        className="border-0 flex-grow-1"
      />
    </Form.Group>
  );
};

export default StringArrayInput;
